import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, pricing } from '../data/content';
export function Bonuses() {
  return <section className="bg-paper py-20 sm:py-24" aria-labelledby="bonuses-title" data-id="element-21" data-mp="pjg4jxu631zc">
      <div className="mx-auto max-w-[920px] px-5 sm:px-8" data-id="element-22" data-mp="au1wct2buqlj">
        <div className="text-center" data-id="element-23" data-mp="fu6c2gvevhap">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-24" data-mp="ft4qvjkolef9">Y aún hay más</p>
          <h2 id="bonuses-title" className="mt-4 text-balance font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-25" data-mp="1tc582o0hoe5">
            Recibe 5 bonos profesionales <em className="text-terra" data-id="element-26" data-mp="3o1lhcx8wzvm3">GRATIS</em>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-27" data-mp="3o3fys1kz95lf">
            Recursos complementarios diseñados para ayudarte a preparar, organizar y conducir tus sesiones con mayor
            claridad. Incluidos sin costo adicional con tu acceso a Maestro de Sesiones.
          </p>
        </div>

        <ul className="mt-12 space-y-5" data-id="element-28" data-mp="1r6z13jwthrn2">
          {bonuses.map(b => <li key={b.label} className="grid gap-x-10 gap-y-5 rounded-[2rem] bg-white p-6 ring-1 ring-cream-line sm:p-8 md:grid-cols-[200px_1fr] md:items-center" data-id="element-29" data-mp="3iclndrr6aixt">
              <div className="mx-auto w-full max-w-[220px] md:max-w-none" data-id="element-30" data-mp="3r8uln33ezbid">
                <img src={b.coverImage} alt={`Portada del ${b.label.replace('#', '')}: ${b.name}`} width={b.coverWidth} height={b.coverHeight} loading="lazy" className="block h-auto w-full" data-id="element-31" data-mp="3n6g1mfo0e5pi" />
              </div>
              <div data-id="element-32" data-mp="38dw3jtfpuoex">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-terra-wash px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-terra-deep" data-id="element-33" data-mp="33hfd2sl1nxyo">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="nruj0hsa7t20" />
                  {b.label}
                </span>
                <h3 className="mt-3 font-display text-2xl leading-tight text-petrol sm:text-[1.75rem]" data-id="element-35" data-mp="3cj6gsc65doob">{b.name}</h3>
                <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-36" data-mp="3hh82l4uyk23h">{b.description}</p>
                <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-37" data-mp="3ljuo6o11cqs8">
                  <span className="text-sm text-ink-mute" data-id="element-38" data-mp="3lhrzc7bmd3p3">
                    Valor: <s className="decoration-ink-mute/60" data-id="element-39" data-mp="3qi5w2t7rsr7t">{b.value}</s>
                  </span>
                  <span className="rounded-md bg-sage-wash px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-sage-deep" data-id="element-40" data-mp="2ttq831kb6pwt">
                    Gratis hoy
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 rounded-[2rem] bg-petrol px-6 py-9 text-center text-paper sm:px-10" data-id="element-41" data-mp="37k3aypicfefa">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream/70" data-id="element-42" data-mp="2a57kgoeybkk8">
            Valor total de los 5 bonos: <s className="text-cream/90 decoration-terra-soft" data-id="element-43" data-mp="2f27rp2njetcx">{pricing.bonusTotal}</s>
          </p>
          <p className="mx-auto mt-4 max-w-xl text-balance font-display text-2xl leading-snug sm:text-3xl" data-id="element-44" data-mp="27iotvq9mwvka">
            Hoy los recibes <em className="text-terra-soft" data-id="element-45" data-mp="22itzvdukbpv0">todos gratis</em> con Maestro de Sesiones
          </p>
        </div>
      </div>
    </section>;
}